<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { digValueInObject } from '../../helpers'

export default {
  name: 'ReportInventoryChart',

  props: ['items', 'selectedLabels', 'mapLabels', 'type', 'showLegendLabels', 'showAxisLabelCurrency', 'colors', 'areaStyle'],

  computed: {
    filterItems () {
      return this.items.map((item) => {
        const subKeys = item.skus || item.items
        return {
          ...item,
          skus: subKeys.map((sku) => {
            return {
              date: item.date,
              ...sku,
            }
          }),
        }
      })
    },
    swapItems () {
      return this.filterItems.reduce((acc, cur) => {
        acc.push((this.filterItems[(this.filterItems.length - 1) - acc.length]))
        return acc
      }, [])
    },
    option () {
      const legendLabels = Object.values(this.mapLabels)
      const colors = [
        '#ff7675', // red
        '#fdcb6e', // blue
        '#0984e3', // green
      ]
      const series = Object.keys(this.mapLabels).map((key, index) => {
        return {
          name: this.mapLabels[key],
          type: this.type, // bar, line
          areaStyle: this.areaStyle,
          data: [
            ...this.swapItems.map((item) => digValueInObject(key, item)),
          ],
          ...(
            this.colors && this.colors.length
              ? {
                color: this.colors[index],
              }
              : null
          ),
        }
      })

      const xAxisItems = this.swapItems.map((item) => item.date)

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: this.type === 'bar' ? 'shadow' : 'line',
          },
          formatter: (params) => {
            let html = ''
            html += `${params[0].axisValue}<br/>`
            for (const param of params) {
              html += `${param.marker} ${param.seriesName}: ${this.getNumber(param.value)}<br/>`
            }
            return html
          },
        },
        legend: {
          show: this.showLegendLabels,
          data: legendLabels,
          selected: {
            ...(
              (() => {
                if (Object.keys(this.selectedLabels).length) {
                  return this.selectedLabels
                }
                const defaultActive = Object.keys(this.mapLabels)
                return Object.keys(this.mapLabels).reduce((acc, cur) => {
                  acc[this.mapLabels[cur]] = !!defaultActive.includes(cur)
                  return acc
                }, {})
              })()
            ),
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter: (value, index) => {
              const currency = this.$store.getters.getCurrency
              const number = this.getNumber(value)
              if (this.showAxisLabelCurrency) {
                return `${number} ${currency}`
              }
              return `${number}`
            },
          },
        },
        xAxis: {
          type: 'category',
          data: xAxisItems,
        },
        series: series,
      }
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportInventoryChart.vue